const progressActionsTypes = {
  READ_USER_PROGRESS_START: 'READ_USER_PROGRESS_START',
  WRITE_USER_PROGRESS_START: 'WRITE_USER_PROGRESS_START',
  READ_USER_PROGRESS_SUCCESS: 'READ_USER_PROGRESS_SUCCESS',
  WRITE_USER_PROGRESS_SUCCESS: 'WRITE_USER_PROGRESS_SUCCESS',
  READ_USER_PROGRESS_FAIL: 'READ_USER_PROGRESS_FAIL',
  WRITE_USER_PROGRESS_FAIL: 'WRITE_USER_PROGRESS_FAIL',
  PROGRESS_TRACKING: 'PROGRESS_TRACKING',
  ERROR_TRACKING: 'ERROR_TRACKING',
  TIME_TRACKING: 'TIME_TRACKING',
  PROGRESS_REFRESH: 'PROGRESS_REFRESH',
  PROGRESS_TIME_START: 'PROGRESS_TIME_START',
  CUSTOM_TEXT_ADD: 'CUSTOM_TEXT_ADD',
  SAVE_PROGRESS: 'SAVE_PROGRESS',
  FETCH_RANDOM_FACT_START: 'FETCH_POEM_START',
  FETCH_RANDOM_FACT_FINISH: 'FETCH_POEM_FINISH',
  FETCH_RANDOM_FACT_ERROR: 'FETCH_POEM_ERROR',
  FETCH_RANDOM_FACT: 'FETCH_POEM',
};

export default progressActionsTypes;
